module.exports = __webpack_public_path__ + "static/media/app_logo.bb841566.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_logo.svg
// module id = 153
// module chunks = 8